module.exports = __webpack_public_path__ + "img/presale-footer.82a3426f.jpg";